/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'components/add': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" _fill="#B2B2B2" d="M4 7v2h3v3h2V9h3V7H9V4H7v3H4z"/>'
  }
})
